import React from 'react';
import styles from './WelcomePage.scss';
import { Text, Heading, Divider, TextButton } from '@wix/design-system';

const HireDesignerExtension = props => {
  const { onGoToArena, t } = props;

  return (
    <div className={styles.extension}>
      <div className={styles.mainDivider}>
        <div className={styles.subDivider}>
          <Divider />
        </div>
        <Heading className={styles.dividerText} size="tiny">
          {t('WELCOME_PAGE_DIVIDER_TEXT')}
        </Heading>
        <div className={styles.subDivider}>
          <Divider />
        </div>
      </div>
      <div className={styles.secondaryContainer}>
        <Text weight="thin">
          <span className={styles.subtitleFont}>{t('WELCOME_PAGE_SECONDARY_SUBTITLE')}</span>
        </Text>
        <TextButton weight="thin" onClick={onGoToArena}>
          <span className={styles.subtitleFont}> {t('WELCOME_PAGE_SECONDARY_CTA')}</span>
        </TextButton>
      </div>
    </div>
  );
};

export default HireDesignerExtension;
